import { useMutation } from '@tanstack/react-query';
import api from '../lib/api.js';

export function useLogin() {
  return useMutation({
    mutationFn: ({ email, password }) =>
      api.post('/auth/login', { email, password }),
  });
}

/**
 * 2FA setup/verify require the preauth token in the Authorization header
 * (not in the body — the backend plugin `requirePreauth` reads `Authorization: Bearer <token>`).
 */
export function useTwoFactorSetup() {
  return useMutation({
    mutationFn: ({ preauth_token }) =>
      api.post('/auth/2fa/setup', undefined, {
        headers: { Authorization: `Bearer ${preauth_token}` },
      }),
  });
}

export function useTwoFactorVerify() {
  return useMutation({
    mutationFn: ({ preauth_token, code }) =>
      api.post('/auth/2fa/verify', { code }, {
        headers: { Authorization: `Bearer ${preauth_token}` },
      }),
  });
}

export function useLogout() {
  return useMutation({
    mutationFn: () => api.post('/auth/logout', {}),
  });
}
